module.exports = __webpack_public_path__ + "static/media/luxanna-icon.781c7e9b.png";